class TabbedContent extends HTMLElement {
  constructor() {
    super();
    this.contentTabs = this.querySelectorAll("[data-content-tab]");
    this.tabButtons = this.querySelectorAll("[data-tab-button]");

    this.querySelector("[data-content-tab].active-tab") ? '' : this.contentTabs[0].classList.add('active-tab')
    this.querySelector("[data-tab-button].active-tab") ? '' : this.tabButtons[0].classList.add('active-tab')

    this.tabButtons.forEach((tabButton) => {
      tabButton.addEventListener("click", () => {
        if (!tabButton.classList.contains("active-tab")) {
          // set all tab buttons to inactive
          this.tabButtons.forEach((tabButton) => {
            tabButton.classList.remove("active-tab");
          });
          // set set selected tab button to active
          tabButton.classList.add("active-tab");

          // switch active content tab
          this.contentTabs.forEach((contentTab) => {
            if (tabButton.dataset.tabIndex == contentTab.dataset.tabIndex) {
              contentTab.classList.add("active-tab");
            } else {
              contentTab.classList.remove("active-tab");
            }
          });
        }
      });
    });
  }
}

customElements.define("tabbed-content", TabbedContent);

// SAMPLE HTML STRUCTURE
// 
// <tabbed-content>
//   <div class="content-tabs">
//     <div class="active-tab" data-content-tab data-tab-index="1">[CONTENT]</div>

//     <div data-content-tab data-tab-index="2">[CONTENT]</div>

//     <div data-content-tab data-tab-index="3">[CONTENT]</div>
//   </div>
//   <div class="tab-buttons">
//     <button class="active-tab" data-tab-button data-tab-index="1">
//       [TAB TITLE]
//     </button>

//     <button data-tab-button data-tab-index="2">[TAB TITLE]</button>

//     <button data-tab-button data-tab-index="3">[TAB TITLE]</button>
//   </div>
// </tabbed-content>
